import autoBind from 'auto-bind'
import GSAP from 'gsap'

class Contact {
  constructor() {
    this.button = document.querySelector('.js-contact__button')
    this.content = document.querySelector('.js-contact__content')
    this.closeButton = document.querySelector('.js-contact__close')
    this.contact = document.querySelector('.js-contact')
    this.items = document.querySelectorAll('.js-contact__item')

    this.state = false
    this.init()
    autoBind(this)
  }

  init() {
    this.button.addEventListener('click', () => {
      this.toggle()
    })

    this.closeButton.addEventListener('click', () => {
      this.close()
    })

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.js-contact')) {
        this.close()
      }
    })

    this.createTimeline()
  }

  toggle() {
    this.state ? this.close() : this.open()
  }

  open() {
    this.animation.play()
    this.state = true
  }

  close() {
    this.animation.reverse()
    this.state = false
  }

  createTimeline() {
    const widthContact = getComputedStyle(document.documentElement).getPropertyValue('--width-contact')

    this.animation = GSAP.timeline({ paused: true })
      .set(this.content, { display: 'flex' })
      .set(this.content, { opacity: 1 })
      .to(this.content, {
        duration: 0.2,
        width: widthContact,
        ease: 'power2.inOut',
      })
      .to(this.content, {
        duration: 0.2,
        height: 'auto',
        ease: 'power2.inOut',
      })
      .to(this.items, {
        duration: 0.2,
        opacity: 1,
        stagger: 0.1,
      })
  }
}

export default Contact
